import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// styles
import { ReadyForDownloadStyled } from "./styles";

const ReadyForDownload = () => {
    const {
        state: { isReadyForDownload }
    } = useContext(AssetDownloadContext);

    if (!isReadyForDownload) {
        return null;
    }

    return <ReadyForDownloadStyled>Ready for download</ReadyForDownloadStyled>;
};

export default ReadyForDownload;
